import React, { useState } from "react";
import { useDispatch } from 'react-redux';
import { showQuantityCalculatorMoreProductInfoPopUp } from "../Actions/QuantityCalculator.action";
import QuantityCalculator from "./QuantityCalculator";
import { translate } from "../Services/translation";

const QuantityCalculatorSelect = (props) => {
    const dispatch = useDispatch();
    const [selectedProduct, setSelectedProduct] = useState();
    const [products] = useState(props.products);

    const scrollToCalculator = () => {
        const element = document.getElementById("calculator");
        setTimeout(() => {
            element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }, 100)
    }

    return (
        <div className="quantity-calculator__select-products">
            <div className="quantity-calculator__products-row">
                <div className="row">
                    {products.map((product) => (
                        <div className="product small-6 medium-6 large-3">
                            <a className={product === selectedProduct ? "active" : "inactive"}
                            key={product.name}
                            onClick={() => setSelectedProduct(product)}>
                                <img src={product.imageUrl} alt={product.name}/>
                                <p>{product.name}</p>
                                <button className="button" onClick={() => scrollToCalculator()}>{translate("quantityCalculatorChooseProduct")}</button>
                            </a>
                            {product === selectedProduct && (
                                <a className="more-info-link" onClick={() => dispatch(showQuantityCalculatorMoreProductInfoPopUp(product.url))}>{translate("quantityCalculatorMoreProductInfo")}</a>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            <div className="row quantity-calculator__selected-product" id="calculator">
                {selectedProduct && (
                    <>
                        <div className="text">
                            <h2 className="title">{selectedProduct.name}</h2>
                            <div className="description" dangerouslySetInnerHTML={{__html: translate("quantityCalculatorTopDescription")}}></div>
                        </div>
                        <div className="specifications">
                            <QuantityCalculator 
                            key={selectedProduct.name} 
                            density={selectedProduct.density} 
                            calculatorVariants={selectedProduct.calculatorVariants}
                            showCompressionCheckbox={selectedProduct.showCompressionCheckbox}/>
                            <div className="image">
                                <img src={selectedProduct.imageUrl}/>
                            </div>
                        </div>
                        <div className="bottom-text" dangerouslySetInnerHTML={{__html: translate("quantityCalculatorBottomDescription")}}></div>
                    </>
                )}
            </div>
        </div>
    )
}

export default QuantityCalculatorSelect;